/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ROUTES } from "../../../../shared";
import { useStyles } from "../../styles";
import SharedFilters from "../SharedFilters";

const DriverFilters = () => {
  const { filtersMainBlock } = useStyles({});

  return (
    <div css={css(filtersMainBlock)} data-testid="driver-filters">
      <SharedFilters
        route={ROUTES.Drivers}
        translateStatus="Drivers##last activity"
      />
    </div>
  );
};

export default DriverFilters;
